var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4974 30.0475C9.1336 30.0475 3.16406 24.0779 3.16406 16.7142C3.16406 9.35039 9.1336 3.38086 16.4974 3.38086C23.8611 3.38086 29.8307 9.35039 29.8307 16.7142C29.8307 24.0779 23.8611 30.0475 16.4974 30.0475ZM16.4974 14.8286L12.7262 11.0573L10.8405 12.943L14.6118 16.7142L10.8405 20.4854L12.7262 22.371L16.4974 18.5998L20.2686 22.371L22.1542 20.4854L18.383 16.7142L22.1542 12.943L20.2686 11.0573L16.4974 14.8286Z",
    fill: "#CC5B5A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/error-icon.0333d0060b1a7570339fb84b1acb4725.svg";
export { ForwardRef as ReactComponent };